export const VIDEO_CURRENT_CLIP_UPDATE = "video_current_clip_update";
export const VIDEO_CURRENT_CLIP_NULL = "video_current_clip_update_null";
